import SEOHead from "@/components/SEOHead";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const PolitiqueConfidentialite = () => {
  return (
    <>
      <SEOHead
        title="Politique de confidentialité"
        description="Politique de confidentialité d'Agence 8020 - Conformité à la Loi 25 du Québec sur la protection des renseignements personnels."
        canonical="/politique-confidentialite"
      />
      
      <main className="min-h-screen bg-background">
        <Navbar />
        
        <div className="pt-32 pb-20">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-4xl md:text-5xl font-bold mb-8">
                Politique de confidentialité
              </h1>
              
              <p className="text-muted-foreground mb-8">
                Dernière mise à jour : {new Date().toLocaleDateString('fr-CA', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>

              <div className="prose prose-lg max-w-none text-foreground">
                <section className="mb-10">
                  <h2 className="text-2xl font-semibold mb-4">1. Introduction</h2>
                  <p className="text-muted-foreground mb-4">
                    Agence 8020 (« nous », « notre » ou « nos ») s'engage à protéger la vie privée des visiteurs de notre site web. 
                    Cette politique de confidentialité explique comment nous recueillons, utilisons, divulguons et protégeons vos 
                    renseignements personnels conformément à la Loi 25 du Québec (Loi sur la protection des renseignements personnels 
                    dans le secteur privé).
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-2xl font-semibold mb-4">2. Responsable de la protection des renseignements personnels</h2>
                  <p className="text-muted-foreground mb-4">
                    Le responsable de la protection des renseignements personnels peut être contacté à :
                  </p>
                  <ul className="list-disc pl-6 text-muted-foreground mb-4">
                    <li>Courriel : info@agence8020.com</li>
                    <li>Téléphone : (514) 123-4567</li>
                  </ul>
                </section>

                <section className="mb-10">
                  <h2 className="text-2xl font-semibold mb-4">3. Renseignements personnels collectés</h2>
                  <p className="text-muted-foreground mb-4">
                    Nous pouvons recueillir les types de renseignements personnels suivants :
                  </p>
                  <ul className="list-disc pl-6 text-muted-foreground mb-4">
                    <li>Nom et prénom</li>
                    <li>Adresse courriel</li>
                    <li>Numéro de téléphone</li>
                    <li>Nom de l'entreprise</li>
                    <li>Informations de navigation (cookies, adresse IP)</li>
                  </ul>
                </section>

                <section className="mb-10">
                  <h2 className="text-2xl font-semibold mb-4">4. Finalités de la collecte</h2>
                  <p className="text-muted-foreground mb-4">
                    Nous utilisons vos renseignements personnels aux fins suivantes :
                  </p>
                  <ul className="list-disc pl-6 text-muted-foreground mb-4">
                    <li>Répondre à vos demandes de renseignements</li>
                    <li>Fournir nos services</li>
                    <li>Améliorer notre site web et nos services</li>
                    <li>Vous envoyer des communications marketing (avec votre consentement)</li>
                    <li>Analyser l'utilisation de notre site web</li>
                  </ul>
                </section>

                <section className="mb-10">
                  <h2 className="text-2xl font-semibold mb-4">5. Cookies et technologies similaires</h2>
                  <p className="text-muted-foreground mb-4">
                    Notre site utilise des cookies pour :
                  </p>
                  <ul className="list-disc pl-6 text-muted-foreground mb-4">
                    <li><strong>Cookies essentiels :</strong> Nécessaires au fonctionnement du site</li>
                    <li><strong>Cookies analytiques :</strong> Pour comprendre comment les visiteurs utilisent notre site</li>
                    <li><strong>Cookies de marketing :</strong> Pour afficher des publicités pertinentes</li>
                  </ul>
                  <p className="text-muted-foreground mb-4">
                    Vous pouvez gérer vos préférences de cookies via la bannière de consentement ou les paramètres de votre navigateur.
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-2xl font-semibold mb-4">6. Conservation des données</h2>
                  <p className="text-muted-foreground mb-4">
                    Nous conservons vos renseignements personnels uniquement pour la durée nécessaire aux fins pour lesquelles 
                    ils ont été recueillis, ou conformément aux exigences légales applicables.
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-2xl font-semibold mb-4">7. Vos droits</h2>
                  <p className="text-muted-foreground mb-4">
                    Conformément à la Loi 25, vous disposez des droits suivants :
                  </p>
                  <ul className="list-disc pl-6 text-muted-foreground mb-4">
                    <li>Droit d'accès à vos renseignements personnels</li>
                    <li>Droit de rectification de vos renseignements</li>
                    <li>Droit à la portabilité de vos données</li>
                    <li>Droit au retrait de votre consentement</li>
                    <li>Droit de déposer une plainte auprès de la Commission d'accès à l'information du Québec</li>
                  </ul>
                  <p className="text-muted-foreground mb-4">
                    Pour exercer ces droits, veuillez nous contacter à l'adresse indiquée ci-dessus.
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-2xl font-semibold mb-4">8. Sécurité</h2>
                  <p className="text-muted-foreground mb-4">
                    Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos renseignements personnels 
                    contre tout accès, utilisation ou divulgation non autorisés.
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-2xl font-semibold mb-4">9. Modifications de cette politique</h2>
                  <p className="text-muted-foreground mb-4">
                    Nous pouvons mettre à jour cette politique de confidentialité périodiquement. La date de la dernière 
                    mise à jour est indiquée en haut de cette page.
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-2xl font-semibold mb-4">10. Contact</h2>
                  <p className="text-muted-foreground mb-4">
                    Pour toute question concernant cette politique de confidentialité ou vos renseignements personnels, 
                    veuillez nous contacter à info@agence8020.com.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </main>
    </>
  );
};

export default PolitiqueConfidentialite;